import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss';
import woman from '../../assets/images/women.jpg';
import shapeImg from '../../assets/images/1.png';

const options = {
    infinite: true,
    arrows: true,
    dots: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
}

class Testimonials extends React.Component {

    state = {
        isOpen: false
    }

    openModal = () => {
        this.setState({isOpen: true})
    }

    render(){
        return (
            <section id="clients" className="feedback-area uk-section uk-feedback">
                <div className="uk-container">
                    <div className="uk-grid uk-grid-match uk-grid-medium uk-child-width-1-2@m uk-child-width-1-1@s">
                        <div className="item">
                            <div className="feedback-img">
                                <img src={woman} alt="Client Testimonials" />

                                <img src={shapeImg} className="shape-img" alt="shape" />

                                {/* Watch Video button removed — placeholder video ID */}
                            </div>
                        </div>

                        <ModalVideo
                            channel='youtube'
                            isOpen={this.state.isOpen}
                            videoId='bk7McNUjWgw'
                            onClose={() => this.setState({isOpen: false})}
                        />

                        <div className="item">
                            <div className="feedback-inner">
                                <div className="uk-section-title section-title">
                                    <span>What Our Clients Say</span>
                                    <h2>Client Testimonials</h2>
                                    <div className="bar"></div>
                                </div>

                                <Slider
                                    className="feedback-slides"
                                    {...options}
                                >
                                    <div className="single-feedback">
                                        <i className="flaticon-quote"></i>
                                        <p>AznTech completely transformed our operations with a custom AI solution that automated our document processing. Their team was deeply technical, communicative, and delivered on time. We've seen a 60% reduction in manual work since launch.</p>

                                        <div className="client">
                                            <h3>Sarah Mitchell</h3>
                                            <span>COO, Meridian Financial Services</span>
                                        </div>
                                    </div>

                                    <div className="single-feedback">
                                        <i className="flaticon-quote"></i>
                                        <p>Working with AznTech to build our SaaS platform was a fantastic experience. They understood our product vision from day one and delivered a scalable, cloud-native application that has handled our growth from 500 to over 20,000 users without a hiccup.</p>

                                        <div className="client">
                                            <h3>James Thornton</h3>
                                            <span>CTO, LaunchPad Technologies</span>
                                        </div>
                                    </div>

                                    <div className="single-feedback">
                                        <i className="flaticon-quote"></i>
                                        <p>The data engineering pipeline AznTech built for us processes millions of records daily with near-zero downtime. Their expertise in both cloud architecture and machine learning gave us insights we simply couldn't get before. Highly recommended.</p>

                                        <div className="client">
                                            <h3>Priya Nair</h3>
                                            <span>Head of Data, RetailEdge Corp</span>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Testimonials;
